
import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.scss']
})
export class TeamsComponent implements OnInit {
  theTeams = []
  game = {
    round: 1,
    rounds: [{
      numb: 1,
      bettingDone: false,
      resultDone: false
    }],
    playing: false,
    bettingDone: false,
    resultDone: false
  }
  constructor() { }
  howManyTeams(e:any, x:any): void {
    localStorage.removeItem('teams')
    this.theTeams = []
    for (let i = 0; i < parseInt(x); i++) {
      this.theTeams.push({
        id: i,
        score: 0,
        bags: 0,
        bet: 0,
        name: 'Team ' + (i + 1),
        rounds: [
          {
            numb: 1,
            score: 0,
            bet: 0,
            sets: 0,
          }
        ]
      })
    }
    localStorage.setItem('teams', JSON.stringify(this.theTeams))
  }

  saveName(team:any, e:any): void {
    team.name = e.target.value
    localStorage.setItem('teams', JSON.stringify(this.theTeams))
  }
  putBet(t, e): void {
    t.bet = e.target.value
  }
  placeBets(): void {
    this.game.bettingDone = true
    this.game.rounds.push(
      {
        numb: this.game.round,
        bettingDone: true,
        resultDone: false
      }
    )
    localStorage.setItem('game', JSON.stringify(this.game))
  }
  setResult(): void {
    this.game.rounds
  }
  startGame(): void {
    this.game.playing = true
    localStorage.setItem('teamisplaying', JSON.stringify(true))
  }
  clearTeams(): void {
    localStorage.removeItem('teamisplaying')
    localStorage.removeItem('teams')
    localStorage.removeItem('game')
    window.location.reload(true)
  }
  ngOnInit(): void {
    if (localStorage.getItem('teams')) {
      this.theTeams = JSON.parse(localStorage.getItem('teams'))
      this.game.playing = JSON.parse(localStorage.getItem('teamisplaying'))
    }
  }

}
